import { SquareKanban, UserSearch, Send, BarChart3, Blocks, Bot } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const ICONS = { SquareKanban, UserSearch, Send, BarChart3, Blocks, Bot };

const Solutions = () => {
    const { content } = useSite();
    const { solutions } = content;

    return (
        <section id="solutions" data-testid="solutions-section" className="bg-white py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="Solutions" heading={solutions.heading} sub={solutions.sub} />

                <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {solutions.items.map((item, i) => {
                        const Icon = ICONS[item.icon] || Blocks;
                        return (
                            <FadeUp key={item.title} delay={(i % 3) * 0.1}>
                                <article
                                    data-testid={`solution-card-${i}`}
                                    className="group h-full rounded-2xl border border-slate-200 bg-mist p-8 transition-all duration-300 hover:-translate-y-1 hover:border-royal/30 hover:bg-white hover:shadow-xl hover:shadow-royal/5"
                                >
                                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-royal/10 transition-colors group-hover:bg-royal">
                                        <Icon className="h-6 w-6 text-royal transition-colors group-hover:text-white" aria-hidden="true" />
                                    </span>
                                    <h3 className="mt-5 font-display text-lg font-bold text-navy sm:text-xl">{item.title}</h3>
                                    <p className="mt-3 text-sm leading-relaxed text-slate-600">{item.text}</p>
                                </article>
                            </FadeUp>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Solutions;
